import { Divider, Stack } from '@mui/material';
import React from 'react';
import { useLocation } from 'react-router-dom';
import { getSectionTabPath } from '@/utils/navigation';
import { ReorderableTabs } from '@/components/layouts/ReorderableTabs';

const getTabTo = (tab, pathname, queryParam) => {
	if (tab.to) return tab.to;
	if (queryParam) return `?${queryParam}=${tab.value}`;
	return getSectionTabPath(pathname, tab.value);
};

export const PageTabsBar = ({ tabs = [], value, onChange, actions, queryParam }) => {
	const location = useLocation();

	if (!tabs.length && !actions) {
		return null;
	}

	return (
		<Stack direction='column' width='100%' pb={1}>
			<Stack direction='row' justifyContent='space-between' alignItems='center' px={3}>
				{tabs.length > 0 ? (
					<ReorderableTabs
						tabs={tabs}
						value={value}
						getTabTo={(tab) => getTabTo(tab, location.pathname, queryParam)}
						onTabClick={(event, nextValue) => onChange?.(event, nextValue)}
					/>
				) : (
					<Stack />
				)}
				{actions && (
					<Stack direction='row' spacing={1} alignItems='center'>
						{actions}
					</Stack>
				)}
			</Stack>
			<Divider />
		</Stack>
	);
};

PageTabsBar.displayName = 'PageTabsBar';
